export async function masonry() {
    const masonryElements = document.querySelectorAll('.masonry');

    if (masonryElements.length) {
        let { initMasonry } = await import(/* webpackMode: "lazy" */ './masonry.async.js');

        initMasonry(masonryElements);
    }
}
